import { Validator } from 'vee-validate'
import otherConfiguration from './otherConfiguration/index.vue';
import UADcutoffs from './UADcutoffs/index.vue';
import UADcutoffLogs from './uadcutofflogs/index.vue';
import CryptoJS from 'crypto-js';
import VueElementLoading from 'vue-element-loading';
import Loader from '../../../../shared/components/loader'
import CONSTANT from './../../../../shared/constants/constant'
//import otherinformation from './otherinformation/index.vue';

export default {
 name: 'approvalrequest',
 components: {
   //DatePicker,
   'first': UADcutoffs,
   'second': UADcutoffLogs,
   'third': otherConfiguration,
   VueElementLoading
 },
 props: ['selectedEditRowData'],
 data() {
   return {
     currentTab: 'First',
     componentKey:1,
     tabs: [
       { key:'First', value:'UAD Cut Offs' },
       { key:'Second', value:'UAD Cut Offs Log' },
       { key:'Third', value:'Other Configuration' }
     ],
     useremail : '',
     isLoading: false,
     useremail : '',
     clientsystemid : '',
     companyshortname : '',
   }
 },
 created:function() {

 },
 computed: {
   // selects all checkbox's option
   currentTabComponent: function () {
     this.componentKey += 1;
     return this.currentTab.toLowerCase()
   }

 },
 mounted() {
   var userdetailEncrypt = window.localStorage.getItem('cargoAutoaccessuserdata')
   var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
   var plaintext = bytes.toString(CryptoJS.enc.Utf8);
   var userdetail = JSON.parse(plaintext);
   this.useremail = userdetail.email;
 },
 methods: {


 }
}



// WEBPACK FOOTER //
// ./src/modules/firstAndLastmilemanagement/views/configuration/UADConfiguration/UADConfiguration.component.js